import {
  Component,
  HostListener,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import {
  FormBuilder,
  Validators,
  FormGroup,
  FormControl,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';

import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { MatStepper } from '@angular/material/stepper';
import { AppConfigService } from 'src/app/Services/app-config.service';
import { BookingGuestsService } from 'src/app/Services/booking-guests.service';
import { CruiseRegionsService } from 'src/app/Services/cruiseregions.service';
import { CruiseThemesService } from 'src/app/Services/cruisetheme.service';
import { CruiseItineraryService } from 'src/app/Services/cruiseitinerary.service';
import { CruiseShipsFilterService } from 'src/app/Services/cruiseshipsfilter.service';
import { CruiseEventsService } from 'src/app/Services/cruiseevents.service';
import { OnboardRebookingService } from 'src/app/Services/onboardrebooking.service';

import * as moment from 'moment';
import { FolioBookingsService } from 'src/app/Services/folio-bookings.service';
import { ConfirmCFARService } from 'src/app/Services/confirm-cfar.service';
import { RecordPaymentService } from 'src/app/Services/record-payment.service';
import { ShipImagesService } from 'src/app/Services/ship-images.service';
import { ActivatedRoute, Router } from '@angular/router';
import { UserData } from 'src/app/Models/employee-and-user-data';
import { cruiseContentEvtCodeFromSession } from 'src/app/utils/voyage-pms-code';

type cardholder = {
  DepositLastName: string;
  DepositFirstName: string;
  guestselector: number;
  DepositZipCode: string;
  DepositCardNumber: string;
  DepositExpirationMonth: string;
  DepositExpirationYear: string;
  DepositCardAuthorizationCode: string;
  PaymentOption: string;
  TermsAccept: boolean;
};
type creditcardData = {
  cardNumber: string;
  month: string;
  year: string;
  cardCode: string;
  zip: string;
  fullName: string;
  amount: number;
};
type sendsecureData = {
  authData: creditauthData;
  cardData: creditcardData;
};
type creditauthData = {
  clientKey: string;
  apiLoginID: string;
};
type bannerimage = {
  highlight: boolean;
  shpid: Int16Array;
  dplDeck: string;
  dplImage: string;
  dplCategoryImage: string;
};
declare var Accept: any;
@Component({
  selector: 'app-onboard-rebooking',
  templateUrl: './onboard-rebooking.component.html',
  styleUrls: ['./onboard-rebooking.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { displayDefaultIndicatorType: false },
    },
    BookingGuestsService,
    CruiseRegionsService,
    CruiseThemesService,
    CruiseItineraryService,
    CruiseShipsFilterService,
    CruiseEventsService,
    OnboardRebookingService,
    FolioBookingsService,
    ConfirmCFARService,
    RecordPaymentService,
    ShipImagesService,
  ],
})
export class OnboardRebookingComponent implements OnInit {
  opaqueData: string = '';
  cardData: creditcardData = {
    cardNumber: '',
    month: '',
    year: '',
    cardCode: '',
    zip: '',
    fullName: '',
    amount: 0,
  };
  authData: creditauthData = {
    clientKey: '',
    apiLoginID: '',
  };
  secureData: sendsecureData = {
    authData: {
      clientKey: '',
      apiLoginID: '',
    },
    cardData: {
      cardNumber: '',
      month: '',
      year: '',
      cardCode: '',
      zip: '',
      fullName: '',
      amount: 0,
    },
  };

  filterexpander: boolean = false;
  userdata?: UserData;
  validsession: boolean | undefined;
  numfolios: number = 0;
  bookingID!: number;
  shpcode: string | undefined;
  shpId: number = 0;
  shipimage: number | undefined;
  BookingGuestsInfo: any;
  bookingguestsdata: any;
  loyaltynum: string = '';
  lastname: string = '';
  FolioBookingsInfo: any[] = [];
  FolioBookingsIndiv: any;
  foliobookingsdata: any;
  selectedTentative: any | undefined;
  OBMarketingdata: any;
  OBMarketingTypeCode: string | undefined;
  CruiseRegionsInfo: any;
  cruiseregiondata: any;
  CruiseThemesInfo: any;
  cruisethemedata: any;
  CruiseItineraryInfo: any;
  cruiseitinerarydata: any;
  CruiseShipInfo: any;
  cruiseshipdata: any;
  CruiseEventInfo: any;
  CruiseEventFilteredInfo: any;
  cruiseeventdata: any;
  CategoryInfo: any;
  categorydata: any;
  RoomInfo: any;
  roomdata: any;
  paymentdata: any;
  cfarconfirmdata: any;
  t2data: any;
  tentativebooking: any;
  Bookingdata: any;
  BookingInfo: any;
  sUnitCode: String | undefined;
  AvailRoomList:
    | {
        Capacity: number;
        CategoryId: number;
        Code: string;
        GroupCode: string;
        GroupName: string;
        Restrict: string;
        SectionCode: string;
        SectionName: string;
        Sort: number;
        Status: string;
        UnitId: number;
      }[]
    | undefined;

  thiscardholder: cardholder = {
    DepositLastName: '',
    DepositFirstName: '',
    guestselector: 0,
    DepositZipCode: '',
    DepositCardNumber: '',
    DepositExpirationMonth: '',
    DepositExpirationYear: '',
    DepositCardAuthorizationCode: '',
    PaymentOption: '',
    TermsAccept: false,
  };
  AirInfo: any;
  airdata: any;
  PrecruiseInfo: any;
  precruisedata: any;
  PostcruiseInfo: any;
  postcruisedata: any;
  LandInfo: any;
  landdata: any;
  MidInfo: any;
  middata: any;
  CFARInfo: any;
  CFARdata: any;

  BookingPriceInfo: any;
  bookingpricedata: any;

  BookingBalanceInfo: any;
  bookingbalancedata: any;

  BookingTransactionInfo: any;
  bookingtransactiondata: any;
  CFARBookingInfo: any = [];
  CFARbookingdata: any;

  step1: boolean = true;
  paymenterror: string = '';
  selectedGuests: any[] = [];
  selectedGuestsString: string | undefined;
  selectedFolio: string | undefined;
  selFolio: string | undefined;
  selectedFilter: string | undefined;
  selectedRegion: string | undefined;
  selectedTheme: string | undefined;
  selectedItinerary: string | undefined;
  //selectedShip: Int16Array | undefined;
  selectedShip: number[] = [];
  selectedEvent: Int16Array | undefined;
  passedStartDate: string | undefined;
  passedEndDate: string | undefined;
  selectedCategory: number | undefined;
  selectedCategoryCode: string | undefined;
  selectedRoom: number | undefined;
  selectedAir: number | undefined;
  selectedPreCruise: number | undefined;
  selectedPostCruise: number | undefined;
  selectedCFAR: string | undefined;
  deliveryType: string = '';
  selectedStartDate: Date | undefined;
  selectedEndDate: Date | undefined;
  minDate!: Date;
  maxDate!: Date;

  precs: any[] = [];
  finalcategories: any[] = [];
  airdeclineditem = ({} = {});
  postcruisedeclineditem = ({} = {});
  precruisedeclineditem = ({} = {});
  airselecteditem = ({} = {});
  postcruiseselecteditem = ({} = {});
  precruiseselecteditem = ({} = {});
  itemlist: any[] = [];
  alreadyscrolled: boolean = false;
  imagepath = '';

  bannerimages: bannerimage[] | undefined;
  bannerimagedata: any;

  firstFormGroup = this._formBuilder.group({
    firstCtrl: ['', Validators.required],
  });
  secondFormGroup = this._formBuilder.group({
    secondCtrl: ['', Validators.required],
  });
  range = new FormGroup({
    start: new FormControl<Date | null>(null),
    end: new FormControl<Date | null>(null),
  });
  paymentForm: any;
  paymentprocessing: boolean = false;
  BookingFineMsg: string = '';
  BookingSubmitted: string = '';
  completepayment: boolean = false;
  savetentativebooking: any;
  SaveTentativeBookingInfo: any;
  NotifyTentativedata: any;
  confirmBookingUrl: string = '';
  flagstep1(step1status: boolean) {
    this.step1 = step1status;
  }
  yearfilter: any;
  monthfilter: any;
  shipfilter: any;
  departportfilter: any;
  yearselfilter: any[] = [];
  monthselfilter: any[] = [];
  shipselfilter: any[] = [];
  departportselfilter: any[] = [];
  inputregion!: string | null;
  inputitin!: string | null;
  @ViewChild('stepper') private Stepper!: MatStepper;

  constructor(
    private _formBuilder: FormBuilder,
    private BookingGuestsService: BookingGuestsService,
    private CruiseRegionService: CruiseRegionsService,
    private CruiseThemesService: CruiseThemesService,
    private CruiseItineraryService: CruiseItineraryService,
    private CruiseShipsFilterService: CruiseShipsFilterService,
    private CruiseEventsService: CruiseEventsService,
    private OnboardRebookingService: OnboardRebookingService,
    private FolioBookingsService: FolioBookingsService,
    private appConfigService: AppConfigService,
    private ConfirmCFARService: ConfirmCFARService,
    private RecordPaymentService: RecordPaymentService,
    private shipImageService: ShipImagesService,
    private router: Router,
    private route: ActivatedRoute
  ) {}
  ngOnInit() {
    // will return the host name and port

    var host = window.location.host;
    this.confirmBookingUrl = this.appConfigService.confirmBookingURL;
    this.inputregion = this.route.snapshot.queryParamMap.get('region');
    this.inputitin = this.route.snapshot.queryParamMap.get('itin');

    this.imagepath = this.appConfigService.imagepath;
    if (host.indexOf('explorer.americancruiselines.com') >= 0)
      this.loadScript(this.appConfigService.authorizeNetAcceptJsUrl);
    else this.loadScript(this.appConfigService.authorizeNetSandboxAcceptJsUrl);
    this.minDate = new Date();
    this.maxDate = new Date(2099, 11, 31);
    this.userdata = JSON.parse(localStorage.getItem('userinfo') || '{}');
    this.shpId = this.userdata?.shipid!;
    this.getBookingGuests();

    this.getCruiseRegions();
    this.getCruiseThemes();
    this.getOBMarketingType();
  }
  loadScript(url: string) {
    var head = document.getElementsByTagName('head')[0];
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = url;
    head.appendChild(script);
  }
  parseFloat(strval: string) {
    return parseFloat(strval);
  }
  getBookingGuests() {
    this.bookingID = this.userdata?.rebuid!;
    this.bookingguestsdata = this.BookingGuestsService.GetBookingGuests(
      this.bookingID
    ).subscribe((bookingguestsdata) =>
      this.setBookingGuests(bookingguestsdata)
    );
  }
  setBookingGuests(resdata: any) {
    this.bookingguestsdata = resdata;
    if (this.bookingguestsdata.GetBookingGuests.Result.Status == 'A') {
      this.BookingGuestsInfo =
        this.bookingguestsdata.GetBookingGuests.BookingGuestList;
      this.getFolioBookings();
      this.setupfromitin();
    }
  }
  setupfromitin() {
    if (this.inputregion != null && this.inputitin != null) {
      this.selectedRegion = this.inputregion;
      this.getCruiseItinerariesFiltered();
      //this.selectedItinerary = this.inputitin;
      this.BookingGuestsInfo.forEach((bg: any) => {
        bg.checked = true;
      });
      this.Stepper.selectedIndex = 4;
      this.step1 = false;
      this.setselectedguests();
      //this.numfolios = this.BookingGuestsInfo.length;
    }
  }
  getFolioBookings() {
    for (let iindex = 0; iindex < this.BookingGuestsInfo.length; iindex++) {
      this.loyaltynum = this.BookingGuestsInfo[iindex].folrepeaterno;
      this.lastname = this.BookingGuestsInfo[iindex].folSurName;
      this.foliobookingsdata = this.FolioBookingsService.GetFolioBookings(
        this.loyaltynum,
        this.lastname
      ).subscribe((foliobookingsdata) =>
        this.setFolioBookings(foliobookingsdata)
      );
    }
  }
  setFolioBookings(resdata: any) {
    this.foliobookingsdata = resdata;
    if (this.foliobookingsdata.GetFolioBookings.Result.Status == 'A') {
      this.FolioBookingsIndiv =
        this.foliobookingsdata.GetFolioBookings.FolioBookingList;
      this.FolioBookingsIndiv.forEach((fb: any) => {
        this.FolioBookingsInfo.push(fb);
      });
    }
  }
  getCruiseRegions() {
    this.cruiseregiondata =
      this.CruiseRegionService.GetCruiseRegions().subscribe(
        (cruiseregiondata) => this.setCruiseRegions(cruiseregiondata)
      );
  }
  setCruiseRegions(resdata: any) {
    this.cruiseregiondata = resdata;
    if (this.cruiseregiondata.GetCruiseRegions.Result.Status == 'A') {
      this.CruiseRegionsInfo =
        this.cruiseregiondata.GetCruiseRegions.CruiseRegionList;
    }
  }

  getCruiseThemes() {
    this.cruisethemedata = this.CruiseThemesService.GetCruiseThemes().subscribe(
      (cruisethemedata) => this.setCruiseThemes(cruisethemedata)
    );
  }
  setCruiseThemes(resdata: any) {
    this.cruisethemedata = resdata;
    if (this.cruisethemedata.GetCruiseThemes.Result.Status == 'A') {
      this.CruiseThemesInfo =
        this.cruisethemedata.GetCruiseThemes.CruiseThemeList;
    }
  }
  setStartDate(startdate: Date) {
    this.resetvalues();
    this.selectedStartDate = startdate;
  }
  setEndDate(enddate: Date) {
    this.resetvalues();
    this.selectedEndDate = enddate;
  }
  setTheme(selecttheme: string) {
    this.resetvalues();
    this.resetdatevalues();
    this.selectedTheme = selecttheme;
  }
  setRegion(selectregion: string) {
    this.resetvalues();
    this.resetdatevalues();
    this.selectedRegion = selectregion;
  }
  setItinerary(selectitinerary: string) {
    this.selectedItinerary = selectitinerary;
  }
  setShip(selectship: number) {
    let i = this.selectedShip.indexOf(selectship);
    if (i == -1) this.selectedShip.push(selectship);
    else this.selectedShip.splice(i, 1);
  }
  setShipStyle(selectshipstyle: string) {
    for (let iindex = 0; iindex < this.CruiseShipInfo.length; iindex++) {
      if (this.CruiseShipInfo[iindex].shpShipStyle == selectshipstyle) {
        let i = this.selectedShip.indexOf(this.CruiseShipInfo[iindex].shpId);
        if (i == -1) {
          this.selectedShip.push(this.CruiseShipInfo[iindex].shpId);
          this.CruiseShipInfo[iindex].selected = true;
        } else {
          this.selectedShip.splice(i, 1);
          this.CruiseShipInfo[iindex].selected = false;
        }
      }
    }
  }
  setTentative(selecttentative: any) {
    this.selectedTentative = selecttentative;
    this.selectedFolio = undefined;
    this.BookingGuestsInfo.forEach((bg: any) => {
      bg.checked = false;
    });
  }

  setEvent(selectevent: Int16Array) {
    this.selectedEvent = selectevent;
    for (var b = 0; b < this.CruiseEventInfo.length; b++) {
      if (this.CruiseEventInfo[b].creevtuid == this.selectedEvent) {
        this.shipimage = this.CruiseEventInfo[b].shpId;
      }
    }
    this.getDeckPlans();
  }
  setAirItem(selectedAir: number) {
    this.selectedAir = selectedAir;
  }
  setPrecruiseItem(selectedPreCruise: number) {
    this.selectedPreCruise = selectedPreCruise;
  }
  setPostcruiseItem(selectedPostCruise: number) {
    this.selectedPostCruise = selectedPostCruise;
  }
  setCFARItem(selectedCFAR: any) {
    this.selectedCFAR = selectedCFAR;
    if (typeof selectedCFAR === 'string' || selectedCFAR instanceof String) {
      if (selectedCFAR.includes(':')) {
        this.selectedCFAR = selectedCFAR.slice(0, selectedCFAR.indexOf(':'));
        let index = selectedCFAR.indexOf(':') + 1;

        this.deliveryType = selectedCFAR.substring(index, index + 1);
      }
    }
  }
  setCategory(selectedCategory: number) {
    this.selectedCategory = selectedCategory;
    if (selectedCategory !== null) {
      this.AvailRoomList = [];
      if (selectedCategory == undefined) {
        for (let i = 0; i < this.CategoryInfo.length; i++) {
          this.getRoomsForCategory(this.CategoryInfo[i].CategoryId);
          //     roomlist.push[catroomlist];
        }
      } else this.getRoomsForCategory(selectedCategory);
    }
  }
  setRoom(selectedRoom: number) {
    this.selectedRoom = selectedRoom;
  }

  resetvalues() {
    this.selectedTheme = undefined;

    this.selectedRegion = undefined;
    this.selectedItinerary = undefined;
    this.selectedShip = [];
    this.selectedEvent = undefined;
  }
  resetdatevalues() {
    this.selectedStartDate = undefined;
    this.selectedEndDate = undefined;
  }
  setselectedguests() {
    this.selectedGuests = this.BookingGuestsInfo.filter(
      (bookingguest: { checked: any }) => bookingguest.checked
    );
    this.numfolios = this.selectedGuests.length;
  }

  getCruiseItinerariesFiltered() {
    if (this.selectedStartDate != undefined)
      this.passedStartDate = moment(this.selectedStartDate).format(
        'YYYY-MM-DD'
      );
    else this.passedStartDate = undefined;

    if (this.selectedEndDate != undefined)
      this.passedEndDate = moment(this.selectedEndDate).format('YYYY-MM-DD');
    else this.passedStartDate = undefined;

    this.cruiseitinerarydata =
      this.CruiseItineraryService.GetCruiseItinerariesFiltered(
        this.passedStartDate,

        this.passedEndDate,
        this.selectedRegion,
        this.selectedTheme
      ).subscribe((cruiseitinerarydata) =>
        this.setCruiseItinerariesFiltered(cruiseitinerarydata)
      );
  }
  setCruiseItinerariesFiltered(resdata: any) {
    this.cruiseitinerarydata = resdata;
    if (this.cruiseitinerarydata.GetCruiseItineraries.Result.Status == 'A') {
      this.CruiseItineraryInfo =
        this.cruiseitinerarydata.GetCruiseItineraries.CruiseItineraryList;
      if (this.inputitin != undefined) {
        this.CruiseItineraryInfo.forEach((itininfo: any) => {
          if (itininfo.creRegionID == this.inputitin) {
            this.selectedItinerary = itininfo.creItinerary;
            this.getCruiseShipsFiltered();
          }
          //this.selectedItinerary = this.inputitin;
        });
      }
    }
  }

  getCruiseShipsFiltered() {
    if (this.selectedStartDate != undefined)
      this.passedStartDate = moment(this.selectedStartDate).format(
        'YYYY-MM-DD'
      );
    else this.passedStartDate = undefined;

    if (this.selectedEndDate != undefined)
      this.passedEndDate = moment(this.selectedEndDate).format('YYYY-MM-DD');
    else this.passedStartDate = undefined;

    this.cruiseshipdata = this.CruiseShipsFilterService.GetCruiseShipsFiltered(
      this.passedStartDate,

      this.passedEndDate,
      this.selectedRegion,
      this.selectedTheme,
      this.selectedItinerary
    ).subscribe((cruiseshipdata) =>
      this.setCruiseShipsFiltered(cruiseshipdata)
    );
  }
  setCruiseShipsFiltered(resdata: any) {
    this.cruiseshipdata = resdata;
    if (this.cruiseshipdata.GetShipsFiltered.Result.Status == 'A') {
      this.CruiseShipInfo = this.cruiseshipdata.GetShipsFiltered.CruiseShipList;
      if (this.inputitin != undefined) {
        this.CruiseShipInfo.forEach((cruiseship: any) => {
          this.selectedShip.push(cruiseship.shpId);
        });

        this.getCruiseEventsFiltered();
      }
    }
  }
  getCruiseEventsFiltered() {
    if (this.selectedStartDate != undefined)
      this.passedStartDate = moment(this.selectedStartDate).format(
        'YYYY-MM-DD'
      );
    else this.passedStartDate = undefined;

    if (this.selectedEndDate != undefined)
      this.passedEndDate = moment(this.selectedEndDate).format('YYYY-MM-DD');
    else this.passedStartDate = undefined;

    this.cruiseeventdata = this.CruiseEventsService.GetCruiseEventsFiltered(
      this.passedStartDate,

      this.passedEndDate,
      this.selectedRegion,
      this.selectedTheme,
      this.selectedItinerary,
      this.selectedShip
    ).subscribe((cruiseeventdata) =>
      this.setCruiseEventsFiltered(cruiseeventdata)
    );
  }
  setCruiseEventsFiltered(resdata: any) {
    this.cruiseeventdata = resdata;
    if (this.cruiseeventdata.GetEventsFiltered.Result.Status == 'A') {
      this.CruiseEventInfo =
        this.cruiseeventdata.GetEventsFiltered.CruiseEventList;
      this.CruiseEventFilteredInfo =
        this.cruiseeventdata.GetEventsFiltered.CruiseEventList;
      this.buildfilters();
    }
  }
  buildfilters() {
    this.shipfilter = [];
    this.departportfilter = [];
    this.yearfilter = [];
    this.monthfilter = [];
    this.shipselfilter = [];
    this.departportfilter = [];
    this.monthselfilter = [];
    // this.CruiseEventInfo.forEach((ce: any) => { });
    this.shipfilter = [
      ...new Set(this.CruiseEventInfo.map((item: any) => item.creshpShipName)),
    ];
    this.departportfilter = [
      ...new Set(this.CruiseEventInfo.map((item: any) => item.creStartPort)),
    ];
    this.yearfilter = [
      ...new Set(
        this.CruiseEventInfo.map((item: any) =>
          moment(item.creevtBegDate).year()
        )
      ),
    ];
    this.monthfilter = [
      ...new Set(
        this.CruiseEventInfo.map((item: any) =>
          moment(item.creevtBegDate).month()
        )
      ),
    ];

    this.shipfilter.forEach((shipsel: any) => {
      var shipobj = {
        ship: shipsel,
        selected: true,
      };
      this.shipselfilter.push(shipobj);
    });

    this.departportfilter.forEach((dptsel: any) => {
      var dptobj = {
        port: dptsel,
        selected: true,
      };
      this.departportselfilter.push(dptobj);
    });
    var currentyear = moment().year();
    for (var yearcount = 0; yearcount < 3; yearcount++) {
      for (var monthcount = 1; monthcount < 13; monthcount++) {
        var monthobj = {
          year: currentyear + yearcount,
          monthnum: monthcount,
          monthname: moment(monthcount, 'M').format('MMM'),
          selected: true,
        };
        this.monthselfilter.push(monthobj);
      }
    }
  }

  getCategoriesForShip() {
    this.categorydata = this.OnboardRebookingService.GetCategoriesforShip(
      this.selectedEvent?.toString()
    ).subscribe((categorydata: any) => this.setCategoriesForShip(categorydata));
  }
  setCategoriesForShip(resdata: any) {
    this.categorydata = resdata;
    this.finalcategories = [];
    if (this.categorydata.GetCategoriesforShip.Result.Status == 'A') {
      this.CategoryInfo = this.categorydata.GetCategoriesforShip.CategoryList;
      if (this.numfolios != undefined) {
        for (let i = 0; i < this.CategoryInfo.length; i++) {
          if (this.CategoryInfo[i].RegularCapacity >= this.numfolios)
            this.finalcategories.push(this.CategoryInfo[i]);
        }
        this.CategoryInfo = this.finalcategories;
      }
    }
  }
  getRoomsForCategory(categoryID: number) {
    this.roomdata = this.OnboardRebookingService.GetRoomsforCategory(
      this.selectedEvent?.toString(),
      categoryID
    ).subscribe((roomdata: any) => this.setRoomsForCategory(roomdata));
  }
  setRoomsForCategory(resdata: any) {
    this.roomdata = resdata;
    //this.numfolios = 2;
    if (this.roomdata.GetRoomsForCategory.Result.Status == 'A') {
      this.RoomInfo = this.roomdata.GetRoomsForCategory.UnitList;
      for (
        let n = 0;
        n < this.roomdata.GetRoomsForCategory.UnitList.length;
        n++
      ) {
        this.sUnitCode =
          this.numfolios &&
          this.roomdata.GetRoomsForCategory.UnitList[n].Code.toString();
        if (this.numfolios != undefined && this.sUnitCode != undefined) {
          if (
            this.roomdata.GetRoomsForCategory.UnitList[n].Capacity >=
              this.numfolios &&
            this.sUnitCode.length < 4
          )
            this.AvailRoomList?.push(
              this.roomdata.GetRoomsForCategory.UnitList[n]
            );
        }
      }
    }
  }
  getDeckPlans() {
    this.bannerimagedata = this.shipImageService
      .getShipImages(this.shipimage, 'All')
      .subscribe((bannerimagedata) => this.setDeckPlanImage(bannerimagedata));
  }

  setDeckPlanImage(resdata: any) {
    this.bannerimagedata = resdata;
    if (this.bannerimagedata.GetShipImages.Result.Status == 'A') {
      this.bannerimages = this.bannerimagedata.GetShipImages.ShipImagesList;
      // else
      //   this.bannerimages =
      //     this.bannerimagedata.GetShipImages.ShipImagesList.filter(
      //       (s: { dplDeck: string }) => s.dplDeck === this.singledeck
      //     );
      // if (this.singledeck !== undefined)
      //   this.bannerimages?.forEach((bannerimage) => {
      //     if (bannerimage.dplDeck !== this.singledeck)
      //       bannerimage.highlight = false;
      //   });
    }
  }
  getAirItemsForCruise() {
    this.airdata = this.OnboardRebookingService.GetItemsforCruise(
      this.selectedEvent,
      'FL',
      ''
    ).subscribe((airdata: any) => this.setAirItemsForCruise(airdata));
  }
  setAirItemsForCruise(resdata: any) {
    this.airdata = resdata;
    if (this.airdata.GetItemsForCruise.Result.Status == 'A') {
      this.AirInfo = this.airdata.GetItemsForCruise.ItemList;
      if (this.AirInfo.length > 0) {
        this.airdeclineditem = {
          ItemId: 0,
          Name: 'Airfare Declined',
        };
        this.AirInfo.push(this.airdeclineditem);
      }
    }
  }
  getPreCruiseItemsForCruise() {
    this.precruisedata = this.OnboardRebookingService.GetItemsforCruise(
      this.selectedEvent,
      'HT',
      'PKG-PRE'
    ).subscribe((precruisedata: any) =>
      this.setPreCruiseItemsForCruise(precruisedata)
    );
  }
  setPreCruiseItemsForCruise(resdata: any) {
    this.precruisedata = resdata;
    if (this.precruisedata.GetItemsForCruise.Result.Status == 'A') {
      this.PrecruiseInfo = this.precruisedata.GetItemsForCruise.ItemList;
      if (this.PrecruiseInfo.length > 0) {
        this.precs = [];
        if (this.numfolios == 1) {
          this.PrecruiseInfo.forEach((pc: any) => {
            if (pc.Name.indexOf('(Double)') == -1) {
              this.precs.push(pc);
            }
          });
          this.PrecruiseInfo = this.precs;
        }
        if (this.numfolios == 2) {
          this.PrecruiseInfo.forEach((pc: any) => {
            if (pc.Name.indexOf('(Single)') == -1) {
              this.precs.push(pc);
            }
          });
          this.PrecruiseInfo = this.precs;
        }
      }
    }
  }
  getPostCruiseItemsForCruise() {
    this.postcruisedata = this.OnboardRebookingService.GetItemsforCruise(
      this.selectedEvent,
      'HT',
      'PKG-POST'
    ).subscribe((postcruisedata: any) =>
      this.setPostCruiseItemsForCruise(postcruisedata)
    );
  }
  setPostCruiseItemsForCruise(resdata: any) {
    this.postcruisedata = resdata;
    if (this.postcruisedata.GetItemsForCruise.Result.Status == 'A') {
      this.PostcruiseInfo = this.postcruisedata.GetItemsForCruise.ItemList;
      if (this.PostcruiseInfo.length > 0) {
        this.precs = [];
        if (this.numfolios == 1) {
          this.PostcruiseInfo.forEach((pc: any) => {
            if (pc.Name.indexOf('(Double)') == -1) {
              this.precs.push(pc);
            }
          });
          this.PostcruiseInfo = this.precs;
        }
        if (this.numfolios == 2) {
          this.PostcruiseInfo.forEach((pc: any) => {
            if (pc.Name.indexOf('(Single)') == -1) {
              this.precs.push(pc);
            }
          });
          this.PostcruiseInfo = this.precs;
        }
        this.postcruisedeclineditem = {
          ItemId: 0,
          Name: 'Post Cruise Package Declined',
        };
        this.PostcruiseInfo.push(this.postcruisedeclineditem);
      }
    }
  }
  getLandPackagesForCruise() {
    this.landdata = this.OnboardRebookingService.GetItemsforCruise(
      this.selectedEvent,
      'OT',
      'LAND'
    ).subscribe((landdata: any) => this.setLandPackagesForCruise(landdata));
  }
  setLandPackagesForCruise(resdata: any) {
    this.landdata = resdata;
    if (this.landdata.GetItemsForCruise.Result.Status == 'A') {
      this.LandInfo = this.landdata.GetItemsForCruise.ItemList;
    }
  }
  getMidCruisePackagesForCruise() {
    this.middata = this.OnboardRebookingService.GetItemsforCruise(
      this.selectedEvent,
      'OT',
      'PKG-MID'
    ).subscribe((middata: any) => this.setMidPackagesForCruise(middata));
  }
  setMidPackagesForCruise(resdata: any) {
    this.middata = resdata;
    if (this.middata.GetItemsForCruise.Result.Status == 'A') {
      this.MidInfo = this.middata.GetItemsForCruise.ItemList;
    }
  }

  getCFAR() {
    this.lookupcategory();
    this.getselectedAirItem();
    this.getselectedPostCruiseItem();
    this.getselectedPreCruiseItem();
    if (Object.keys(this.airselecteditem).length != 0)
      this.itemlist.push(this.airselecteditem);
    if (Object.keys(this.precruiseselecteditem).length != 0)
      this.itemlist.push(this.precruiseselecteditem);
    if (Object.keys(this.postcruiseselecteditem).length != 0)
      this.itemlist.push(this.postcruiseselecteditem);

    this.CFARdata = this.OnboardRebookingService.GetCFAR(
      this.selectedEvent,
      this.numfolios,
      this.selectedCategoryCode,
      'ONBOARD15',
      this.itemlist
    ).subscribe((CFARdata: any) => this.setCFAR(CFARdata));
  }

  setCFAR(resdata: any) {
    this.CFARdata = resdata;
    if (this.CFARdata.GetCFAR.Result.Status == 'A') {
      this.CFARInfo = this.CFARdata.GetCFAR.ItemList;
    }
  }
  lookupcategory() {
    this.CategoryInfo.forEach((cat: any) => {
      if (cat.CategoryId == this.selectedCategory) {
        this.selectedCategoryCode = cat.Code;
      }
    });
  }
  getselectedAirItem() {
    this.AirInfo.forEach((air: any) => {
      if (air.ItemId == this.selectedAir) {
        this.airselecteditem = air;
      }
    });
  }
  getselectedPreCruiseItem() {
    this.PrecruiseInfo.forEach((pre: any) => {
      if (pre.ItemId == this.selectedPreCruise) {
        this.precruiseselecteditem = pre;
      }
    });
  }
  getselectedPostCruiseItem() {
    this.PostcruiseInfo.forEach((post: any) => {
      if (post.ItemId == this.selectedPostCruise) {
        this.postcruiseselecteditem = post;
      }
    });
  }
  getOBMarketingType() {
    this.shpcode = cruiseContentEvtCodeFromSession(this.userdata).substring(
      0,
      3
    );
    this.OBMarketingdata = this.OnboardRebookingService.GetOBMarketingType(
      this.shpcode
    ).subscribe((OBMarketingdata) => this.setOBMarketingType(OBMarketingdata));
  }

  setOBMarketingType(resdata: any) {
    this.OBMarketingdata = resdata;
    if (this.OBMarketingdata.GetOnboardMarketingType.Result.Status == 'A') {
      this.OBMarketingTypeCode =
        this.OBMarketingdata.GetOnboardMarketingType.ShipInfo.shpRebookMktTypeCode;
    }
  }
  makeTentativeBooking() {
    this.itemlist = [];
    if (this.selectedAir != undefined)
      this.itemlist.push({ itemId: this.selectedAir });
    if (this.selectedPreCruise != undefined)
      this.itemlist.push({ itemId: this.selectedPreCruise });
    if (this.selectedPostCruise != undefined)
      this.itemlist.push({ itemId: this.selectedPostCruise });
    //auto push land packages and mid cruise packages
    this.LandInfo.forEach((landpackage: any) => {
      this.itemlist.push({ itemId: landpackage.ItemId });
    });
    this.MidInfo.forEach((midpackage: any) => {
      this.itemlist.push({ itemId: midpackage.ItemId });
    });

    if (this.selectedGuests != undefined && this.selectedGuests.length > 0) {
      this.selectedGuestsString = this.selectedGuests[0].refFolfolioId;
      let i = 0;
      this.selectedGuests.forEach((guest: any) => {
        if (i > 0) this.selectedGuestsString += ';' + guest.refFolfolioId;
        i++;
      });
    }

    //add the mid cruise and land package items automatically

    this.tentativebooking = this.OnboardRebookingService.MakeTentativeBooking(
      this.selectedEvent,
      this.selectedGuestsString,
      this.selectedCategory,
      this.OBMarketingTypeCode,
      this.selectedRoom?.toString(),
      this.selectedCFAR,
      this.deliveryType,
      this.itemlist
    ).subscribe((tentativebooking: any) =>
      this.getTentativeBooking(tentativebooking)
    );
  }

  getTentativeBooking(resdata: any) {
    this.Bookingdata = resdata;
    if (this.Bookingdata.MakeTentativeBooking.Result.Status == 'A') {
      this.BookingInfo =
        this.Bookingdata.MakeTentativeBooking.ResTentativeBooking;
      this.bookingID = this.BookingInfo.bookingId;
      this.FolioBookingsInfo = [];
      this.getFolioBookings();
      this.getBookingPrice();
      this.getBookingBalance();
      this.getBookingTransactions();
      this.saveTentativeBooking();
      //this.getCFARBooking();
    }
  }

  saveTentativeBooking() {
    this.itemlist = [];
    if (this.selectedAir != undefined)
      this.itemlist.push({ itemId: this.selectedAir });
    if (this.selectedPreCruise != undefined)
      this.itemlist.push({ itemId: this.selectedPreCruise });
    if (this.selectedPostCruise != undefined)
      this.itemlist.push({ itemId: this.selectedPostCruise });

    if (this.selectedGuests != undefined && this.selectedGuests.length > 0) {
      this.selectedGuestsString = this.selectedGuests[0].refFolfolioId;
      let i = 0;
      this.selectedGuests.forEach((guest: any) => {
        if (i > 0) this.selectedGuestsString += ';' + guest.refFolfolioId;
        i++;
      });
    }

    for (var b = 0; b < this.CruiseEventInfo.length; b++) {
      if (this.CruiseEventInfo[b].creevtuid == this.selectedEvent) {
        var DepartureDate = this.CruiseEventInfo[b].creevtBegDate;
        var CruiseEndDate = this.CruiseEventInfo[b].creevtEndDate;
        var NewCruiseCode = this.CruiseEventInfo[b].creevtCode;
        var FacilityID = this.CruiseEventInfo[b].crefacUid;
        var FacilityName = this.CruiseEventInfo[b].creshpShipName;
      }
    }
    for (var c = 0; c < this.CategoryInfo.length; c++) {
      if (this.CategoryInfo[c].CategoryId == this.selectedCategory)
        var CategoryCode = this.CategoryInfo[c].Code;
    }
    if (this.BookingGuestsInfo.length == 1) {
      if (this.BookingGuestsInfo[0].checked) {
        var folioID1 = this.BookingGuestsInfo[0].refFolfolioId;
        var folio1name = this.BookingGuestsInfo[0].folFullNameSal;
      }
    }
    if (this.BookingGuestsInfo.length == 2) {
      if (this.BookingGuestsInfo[0].checked) {
        var folioID1 = this.BookingGuestsInfo[0].refFolfolioId;
        var folio1name = this.BookingGuestsInfo[0].folFullNameSal;

        if (this.BookingGuestsInfo[1].checked) {
          var folioID2 = this.BookingGuestsInfo[1].refFolfolioId;
          var folio2name = this.BookingGuestsInfo[1].folFullNameSal;
        }
      } else {
        if (this.BookingGuestsInfo[1].checked) {
          var folioID2 = this.BookingGuestsInfo[1].foluid;
          var folio2name = this.BookingGuestsInfo[1].folFullNameSal;
        }
      }
    }
    for (var d = 0; d < this.RoomInfo.length; d++) {
      if (this.RoomInfo[d].UnitId == this.selectedRoom)
        var UnitCode = this.RoomInfo[d].Code;
    }
    if (UnitCode == undefined) {
      UnitCode = "0";
      this.selectedRoom = 0;
    }

    this.savetentativebooking =
      this.OnboardRebookingService.SaveTentativeBooking(
        // evtuid: Int16Array | undefined,
        this.selectedEvent,
        //     folioId1: string | undefined,
        folioID1,
        //     folioId2: string | undefined,
        folioID2,
        //     CategoryCode: string | undefined,
        CategoryCode,
        //     CategoryId: number | undefined,
        this.selectedCategory,
        //     CurrentCruiseCode: string | undefined,
        this.userdata?.evtcode!,
        //     RoomNumber: string | undefined,
        UnitCode,
        //     UnitID: number | undefined,
        this.selectedRoom,
        //     NewCruiseCode: string | undefined,
        NewCruiseCode,
        //     FacilityID: number | undefined,
        FacilityID,
        //     FacilityName: string | undefined,
        FacilityName,
        //     DepartureDate: string | undefined,
        DepartureDate,
        //     FullName1: string | undefined,
        folio1name,
        //     FullName2: string | undefined,
        folio2name,
        //     InvoiceID: string | undefined,
        this.BookingInfo.invoiceId,
        //     NewBookingID: string | undefined,
        this.bookingID.toString(),
        //     Paymentstatus: string | undefined,
        'Tentative',
        this.itemlist
      ).subscribe((tentativebooking: any) =>
        this.getsaveTentativeBooking(this.savetentativebooking)
      );

    this.NotifyTentativedata =
      this.OnboardRebookingService.SendTentativeNotification(
        this.shpId,
        folio1name,
        //     FullName2: string | undefined,
        folio2name,
        '',
        //     FacilityName: string | undefined,
        FacilityName,
        //     DepartureDate: string | undefined,
        moment(DepartureDate).format('MMM DD,YYYY') +
          '-' +
          moment(CruiseEndDate).format('MMM DD,YYYY'),

        this.bookingID
      ).subscribe((tentativebooking: any) =>
        this.setNotifyTentative(this.NotifyTentativedata)
      );
  }

  getsaveTentativeBooking(resdata: any) {
    this.savetentativebooking = resdata;
    if (this.savetentativebooking.SaveTentativeBooking.Result.Status == 'A') {
      this.SaveTentativeBookingInfo =
        this.savetentativebooking.SaveTentativeBooking.ResTentativeBooking;
    }
  }

  setNotifyTentative(resdata: any) {
    this.NotifyTentativedata = resdata;
    if (
      this.NotifyTentativedata.SendTentativeNotification.Result.Status == 'A'
    ) {
    
    }
  }
  getBookingPrice() {
    this.bookingpricedata = this.OnboardRebookingService.GetBookingPrice(
      this.bookingID.toString()
    ).subscribe((bookingpricedata) => this.setBookingPrice(bookingpricedata));
  }

  setBookingPrice(resdata: any) {
    this.bookingpricedata = resdata;
    if (this.bookingpricedata.GetBookingPrice.Result.Status == 'A') {
      this.BookingPriceInfo = this.bookingpricedata.GetBookingPrice.Price;
    }
  }
  getCFARBooking() {
    this.CFARbookingdata = this.OnboardRebookingService.getCFARBooking(
      this.bookingID,
      this.selectedEvent,
      this.numfolios
    ).subscribe((CFARbookingdata) => this.setCFARBooking(CFARbookingdata));
  }

  setCFARBooking(resdata: any) {
    this.CFARbookingdata = resdata;
    if (this.CFARbookingdata.GetCFARBooking.Result.Status == 'A') {
      this.CFARBookingInfo = this.CFARbookingdata.GetCFARBooking.ItemList;
    }
  }
  getBookingBalance() {
    this.bookingbalancedata = this.OnboardRebookingService.GetBookingBalance(
      this.bookingID.toString()
    ).subscribe((bookingbalancedata) =>
      this.setBookingBalance(bookingbalancedata)
    );
  }

  setBookingBalance(resdata: any) {
    this.bookingbalancedata = resdata;
    if (this.bookingbalancedata.GetBookingBalance.Result.Status == 'A') {
      this.BookingBalanceInfo =
        this.bookingbalancedata.GetBookingBalance.FolioBookingBalanceList[0];
      this.selectedEvent = this.BookingBalanceInfo.evtUid;
      this.getCFARBooking();
    }
  }

  getBookingTransactions() {
    this.bookingtransactiondata =
      this.OnboardRebookingService.getBookingTransactions(
        this.bookingID
      ).subscribe((bookingtransactiondata) =>
        this.setBookingTransactions(bookingtransactiondata)
      );
  }

  setBookingTransactions(resdata: any) {
    this.bookingtransactiondata = resdata;
    if (
      this.bookingtransactiondata.GetBookingTransactions.Result.Status == 'A'
    ) {
      this.BookingTransactionInfo =
        this.bookingtransactiondata.GetBookingTransactions.BookingTransactionList;
    }
  }

  ConfirmTentative(stepper: MatStepper) {
    this.BookingInfo = this.selectedTentative;
    this.bookingID = this.selectedTentative.rebuid;

    this.numfolios = this.selectedTentative.rebPeopleCount;
    //this.getFolioBookings();
    this.getBookingPrice();
    this.getBookingBalance();
    this.getBookingTransactions();
    stepper.selectedIndex = 8;
    //this.getCFARBooking();
  }
  paymentFormUpdate(opaqueData: any) {
    //  document.getElementById("dataDescriptor").value = opaqueData.dataDescriptor;
    //  document.getElementById("dataValue").value = opaqueData.dataValue;
    this.opaqueData = opaqueData.dataValue;
    // If using your own form to collect the sensitive data from the customer,
    // blank out the fields before submitting them to your server.
    this.thiscardholder.DepositCardNumber = '';
    this.thiscardholder.DepositExpirationMonth = '';
    this.thiscardholder.DepositExpirationYear = '';
    this.thiscardholder.DepositCardAuthorizationCode = '';
    this.thiscardholder.DepositZipCode = '';
    //record the payment in Resco
    this.RecordPayment(opaqueData);
    // document.getElementById("paymentForm").submit();
  }
  responseHandler(response: any) {
    try {
      if (response.messages.resultCode === 'Error') {
        this.paymentprocessing = false;
        var i = 0;
        while (i < response.messages.message.length) {
          i = i + 1;
        }
        for (var i = 0; i < response.messages.message.length; i++) {
          switch (response.messages.message[i].code) {
            case 'E_WC_07':
            case 'E_WC_08':
            case 'E_WC_06':
              alert(
                'We have encountered an error processing your payment.  Please confirm your expiration date and resubmit, or contact us at 800-894-8570 for assistance.'
              );
              break;
            case 'E_WC_04':
            case 'E_WC_05':
              alert(
                'We have encountered an error processing your payment.  Please confirm your card information and resubmit, or contact us at 800-894-8570 for assistance.'
              );
              break;
            case 'E_WC_15':
              alert(
                'We have encountered an error processing your payment.  Please provide a valid CVV and resubmit, or contact us at 800-894-8570 for assistance.'
              );
              break;
            case 'E_WC_16':
              alert(
                'We have encountered an error processing your payment.  Please provide a valid Zip Code and resubmit, or contact us at 800-894-8570 for assistance.'
              );
              break;
            case 'E_WC_17':
              alert(
                'We have encountered an error processing your payment.  Please provide a valid first and last name for the card holder and resubmit, or contact us at 800-894-8570 for assistance.'
              );
              break;
            default:
              alert(
                'We have encountered an error processing your payment.  Please confirm your card & billing information and resubmit, or contact us at 800-894-8570 for assistance.'
              );
              break;
          }
        }
      } else {
        //this.paymentFormUpdate(response.opaqueData);
        var opaqueData = response.opaqueData.dataValue;
        // If using your own form to collect the sensitive data from the customer,
        // blank out the fields before submitting them to your server.

        // document.getElementById('DepositCardNumber').value = '';
        this.thiscardholder.DepositCardNumber = '';
        this.thiscardholder.DepositExpirationMonth = '';
        this.thiscardholder.DepositExpirationYear = '';
        this.thiscardholder.DepositCardAuthorizationCode = '';
        this.thiscardholder.DepositZipCode = '';
        //record the payment in Resco
        this.RecordPayment(opaqueData);
      }
    } catch (error) {
      // Error handled silently; payment error messaging is done via alerts above
    }
  }

  sendPaymentDataToAnet() {
    this.paymentprocessing = true;

    //this.paymenterror = undefined;
    this.authData.clientKey = this.appConfigService.clientKey;
    this.authData.apiLoginID = this.appConfigService.apiLoginID;

    this.cardData.cardNumber = this.thiscardholder.DepositCardNumber;
    this.cardData.month = this.thiscardholder.DepositExpirationMonth;
    this.cardData.year = this.thiscardholder.DepositExpirationYear;
    this.cardData.cardCode = this.thiscardholder.DepositCardAuthorizationCode;
    var firstName = this.thiscardholder.DepositFirstName;
    var lastName = this.thiscardholder.DepositLastName;
    this.cardData.zip = this.thiscardholder.DepositZipCode;

    this.cardData.fullName = firstName + ' ' + lastName;

    this.cardData.amount = 1000; //PaymentInfo.amount;

    this.secureData.authData = this.authData;
    this.secureData.cardData = this.cardData;

    Accept.dispatchData(this.secureData, this.responseHandler);
  }
  RecordPayment(opaqueData: string) {
    this.paymentprocessing = true;
    //if (($scope.CFARStatus == "D" && $scope.AddCFAR == "add") || ($scope.CFARStatus == "P" && $scope.ConfirmCFAR == true)) {
    if (this.CFARBookingInfo[0].GroupType == 'P') {
      this.cfarconfirmdata = this.ConfirmCFARService.ConfirmCFAR(
        this.bookingID,
        this.CFARBookingInfo[0].ItemId
      ).subscribe((bookingtransactiondata) =>
        this.checkCFAR(this.cfarconfirmdata)
      );
    } else this.T2Booking();
  }
  checkCFAR(resdata: any) {
    this.cfarconfirmdata = resdata;
    if (this.cfarconfirmdata.ConfirmCFAR.Result.Status == 'A') {
      this.T2Booking();
    }
  }

  T2Booking() {
    this.t2data = this.OnboardRebookingService.ChangeBookingStatusT2(
      this.bookingID
    ).subscribe((t2data) => this.set2Booking(t2data));
  }

  set2Booking(resdata: any) {
    this.t2data = resdata;
    if (this.t2data.ResChangeBookingStatusT2.Result.Status == 'A') {
      this.AuthorizePayment();
    }
    if (this.t2data.ResChangeBookingStatusT2.Result.Status == 'R') {
      this.BookingFineMsg =
        'We are unable to confirm your stateroom selection at this time, the room you requested is no longer available,  please contact us at 1-888-322-7057.';
      alert(this.BookingFineMsg);
      this.BookingSubmitted = 'False';
      this.completepayment = false;
    }
  }

  AuthorizePayment() {
    this.paymentdata = this.RecordPaymentService.AuthorizePayment(
      this.bookingID,
      false,
      this.selFolio,
      //this.thiscardholder.PaymentOption,
      1000,
      this.selectedEvent,
      this.thiscardholder.DepositZipCode,
      this.thiscardholder.DepositFirstName,
      this.thiscardholder.DepositLastName,
      this.opaqueData
    ).subscribe((paymentdata) => this.setPaymentData(this.paymentdata));
  }
  setPaymentData(resdata: any) {
    this.paymentdata = resdata;
    if (this.paymentdata.ConfirmCFAR.Result.Status == 'A') {
      alert('Payment Successful');
      this.paymentprocessing = false;
    } else if (this.paymentdata.ConfirmCFAR.Result.Status == 'A') {
      alert('Payment Failed');
      this.paymenterror =
        'There was a problem processing your credit card, Please confirm your payment information or contact customer service at 1- 800 - 894 - 8570';
    }
  }
  applyfilter() {
    const filtered = this.CruiseEventInfo.filter((a: any) =>
      this.shipselfilter.some(
        (b) => b.ship === a.creshpShipName && b.selected === true
      )
    );
    const filtered2 = filtered.filter((a: any) =>
      this.departportselfilter.some(
        (b) => b.port === a.creStartPort && b.selected === true
      )
    );
    const filtered3 = filtered2.filter((a: any) =>
      this.monthselfilter.some(
        (b) =>
          moment(a.creevtBegDate).month() === b.monthnum &&
          moment(a.creevtBegDate).year() === b.year &&
          b.selected === true
      )
    );
    // const filtered = this.CruiseEventInfo.filter((a: any) =>
    //   filter.some(
    //     (b) =>
    //       moment(a.creevtBegDate).isSame(b.date.month, 'month') &&
    //       b.ship === a.creshpShipName &&
    //       b.startport === a.creStartPort
    //   )
    // );
    this.CruiseEventFilteredInfo = filtered3;
  }
  setyear(year: number, checked: boolean) {
    this.monthselfilter.forEach((monthyear) => {
      if (monthyear.year === year) {
        monthyear.selected = checked;
      }
    });
  }

  @HostListener('document:scroll', ['$event'])
  public onViewportScroll() {
    this.alreadyscrolled = true;
  }
}
